import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-steps',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './steps.component.html',
  styleUrl: './steps.component.scss',
})
export class StepsComponent {
  steps = [
    { n: 1, title: 'Prowadzący odpala grę', text: 'Wyświetla ją na projektorze, a kod QR widzi cała sala.' },
    { n: 2, title: 'Goście skanują kod QR', text: 'Jeden skan, zero instalacji. Dołączają w kilka sekund.' },
    { n: 3, title: 'Każdy uczestniczy po swojemu', text: 'Ze swojego miejsca, bez wychodzenia na środek.' },
    { n: 4, title: 'Sala reaguje razem', text: 'Wyniki lecą na duży ekran, a napięcie rośnie samo.' },
  ];
}
